import * as React from "react";
import { clsx } from "@plans/appkit";
import { dangerouslyParseMarkdown } from "~/lib/utils/dangerously-parse-markdown";

export type MarkdownProps = {
	children?: string | null;
	className?: string;
};

export function Markdown({ children, className }: MarkdownProps) {
	const parsedMarkdown = React.useMemo(
		() => (children ? dangerouslyParseMarkdown(children) : undefined),
		[children],
	);

	return parsedMarkdown ? (
		<div
			className={clsx("global-richtext-content contents", className)}
			dangerouslySetInnerHTML={{ __html: parsedMarkdown }}
		/>
	) : null;
}
